import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._boundHandleSubmission = this.handleSubmission.bind(this)
    this.element.addEventListener("turbo:submit-end", this._boundHandleSubmission)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this._boundHandleSubmission)
  }

  handleSubmission(event) {
    if (event.detail.success) {
      const editor = this.element.querySelector("trix-editor")
      if (editor) editor.value = ""
    }
  }
} 